import { render, staticRenderFns } from "./Mouth.vue?vue&type=template&id=22322966&scoped=true&"
import script from "./Mouth.vue?vue&type=script&lang=js&"
export * from "./Mouth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22322966",
  null
  
)

export default component.exports